import { useQuery } from "@tanstack/react-query";

import { useAppContext } from "./useAppContext";
import { useProductCode } from "./useProductCode";

/** Return the available fonts for this product */
export function useFontFamilies() {
	const { client, editor, reactQueryNoReloadOptions } = useAppContext();

	const productCode = useProductCode();

	const loadFontFamilies = async () => {
		if (!productCode) return [];
		const result = await client.getFontFamiliesInfoForProduct(
			productCode,
			editor.assets.fontFamilies,
		);
		return result.fontFamilies;
	};

	return useQuery<eXpress.core.FontFamily[]>({
		queryKey: ["use-font-families", productCode],
		queryFn: loadFontFamilies,
		...reactQueryNoReloadOptions,
	});
}
